import { combineReducers } from 'redux'

import bigModal from './bigModal'
import appConfig from './appConfig'

import { IReduxBigModal } from './bigModal/props'
import { IReduxAppConfig } from './appConfig/props'

export default combineReducers({
  bigModal,
  appConfig,
})

export type DefaultReducerProps = {
  bigModal?: IReduxBigModal
  appConfig?: IReduxAppConfig
}
